import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationCancel, NavigationStart, RouteConfigLoadEnd, RouteConfigLoadStart, Router } from '@angular/router';
import { AppInsightsService } from '@modules/common/services/app-insights.service';
import { IsLoadingService } from '@modules/common/services/is-loading.service';
import { UserSessionTimeoutService } from '@modules/common/services/user-session-timeout.service';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-root',
    template: '<router-outlet></router-outlet><app-loading-overlay></app-loading-overlay>'
})
export class AppComponent {
    constructor(
        userSessionTimeoutService: UserSessionTimeoutService,
        appInsightsService: AppInsightsService,
        isLoadingService: IsLoadingService,
        @Inject(DOCUMENT) document: Document,
        private router: Router,
        private matDialog: MatDialog
    ) {
        userSessionTimeoutService.initialize();
        appInsightsService.initialize();

        this.router.events
            .pipe(filter(event => event instanceof NavigationStart))
            .subscribe(() => {
                this.matDialog.closeAll();
            });

        //Show spinner when lazy loading modules from routes
        let isLoading = false;
        this.router.events
            .pipe(filter(event => event instanceof RouteConfigLoadStart))
            .subscribe(() => {
                isLoading = true;
                isLoadingService.setLoading();
            });

        //Clear spinner when lazy loading is done
        this.router.events
            .pipe(filter(event => event instanceof RouteConfigLoadEnd || event instanceof NavigationCancel))
            .subscribe(() => {
                if (isLoading) {
                    isLoadingService.clearLoading();
                    isLoading = false;
                }
            });

        document.body.addEventListener('dragenter', onDrag);
        document.body.addEventListener('dragover', onDrag);
        document.body.addEventListener('drop', onDrag);
    }
}

function onDrag(e: DragEvent): void {
    if (e.dataTransfer) {
        e.dataTransfer.dropEffect = 'none';
        e.dataTransfer.effectAllowed = 'none';
    }
    e.preventDefault();
    e.stopPropagation();
}
